import { render, staticRenderFns } from "./ServiceAlertView.vue?vue&type=template&id=f1a9e80a&scoped=true"
import script from "./ServiceAlertView.vue?vue&type=script&lang=js"
export * from "./ServiceAlertView.vue?vue&type=script&lang=js"
import style0 from "./ServiceAlertView.vue?vue&type=style&index=0&id=f1a9e80a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1a9e80a",
  null
  
)

export default component.exports